import { render, staticRenderFns } from "./etapas.vue?vue&type=template&id=6b019a8c&scoped=true"
import script from "./etapas.vue?vue&type=script&lang=js"
export * from "./etapas.vue?vue&type=script&lang=js"
import style0 from "./etapas.vue?vue&type=style&index=0&id=6b019a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b019a8c",
  null
  
)

export default component.exports